module.exports = __webpack_public_path__ + "img/27.9a9f15f7.png";